export type MaterialRequerido = 'Bovedilla EPS 63 x 300' | 'Casetón EPS' | 'Vigueta' | 'Varios / No sé todavía'

export const MATERIAL_OPTIONS: MaterialRequerido[] = [
  'Bovedilla EPS 63 x 300',
  'Casetón EPS',
  'Vigueta',
  'Varios / No sé todavía',
]

export interface Lead {
  nombre: string
  telefono: string
  email: string
  ciudad: string
  material: MaterialRequerido
  cantidad: string
  fecha: string
  consentimiento: boolean
}

export const EMPTY_LEAD: Lead = {
  nombre: '',
  telefono: '',
  email: '',
  ciudad: '',
  material: 'Bovedilla EPS 63 x 300',
  cantidad: '',
  fecha: '',
  consentimiento: false,
}
